"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-411fba48"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bgc" }, null, -1));
const _hoisted_2 = { class: "max-content" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "header" };
const _hoisted_5 = { class: "title" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "数据字典", -1));
const _hoisted_7 = { class: "func" };
const _hoisted_8 = { class: "box" };
const _hoisted_9 = { class: "searchBoxContent" };
const _hoisted_10 = { class: "tableContent" };
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const dictionaries_1 = require("../../service/dictionaries");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const innerOrOuter = (0, vue_3.ref)(true);
        const tableData = (0, vue_3.ref)([]);
        const indexNum = (0, vue_3.ref)(0);
        const changeInnerOrOuter = () => {
            innerOrOuter.value = !innerOrOuter.value;
        };
        const inputChange = (value) => __awaiter(this, void 0, void 0, function* () {
            const res = yield (0, dictionaries_1.queryDataDict)(value);
            tableData.value = res.data.map((item, index) => {
                return Object.assign({ key: index + 1 }, item);
            });
            indexNum.value = tableData.value.length;
        });
        const goBack = () => {
            router.back();
        };
        (0, vue_3.onMounted)(() => {
            inputChange("");
        });
        const columns = [
            {
                title: '序号',
                dataIndex: 'key',
                key: 'key',
                width: '5%'
            },
            {
                title: '字段名称',
                dataIndex: 'cname',
                key: 'cname',
            },
            {
                title: '英文名称',
                dataIndex: 'ename',
                key: 'ename',
            },
            {
                title: '字段描述',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: '取值系统',
                key: 'vsystem',
                dataIndex: 'vsystem',
            },
            {
                title: '取值表名',
                key: 'tableName',
                dataIndex: 'tableName',
            },
            {
                title: '取值字段名',
                key: 'fieldName',
                dataIndex: 'fieldName',
            },
            {
                title: '取值逻辑',
                key: 'logic',
                dataIndex: 'logic',
            },
            {
                title: '数据更新频次',
                key: 'updateRate',
                dataIndex: 'updateRate',
            },
            {
                title: '字典更新时间',
                key: 'dictUpdateTime',
                dataIndex: 'dictUpdateTime',
            },
        ];
        return (_ctx, _cache) => {
            const _component_Header = (0, vue_2.resolveComponent)("Header");
            const _component_SearchBox = (0, vue_2.resolveComponent)("SearchBox");
            const _component_a_button = (0, vue_2.resolveComponent)("a-button");
            const _component_a_table = (0, vue_2.resolveComponent)("a-table");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                (0, vue_2.createVNode)(_component_Header),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                _hoisted_6,
                                (0, vue_2.createElementVNode)("span", null, "指标数量:" + (0, vue_2.toDisplayString)(indexNum.value) + "个", 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)({ chooseBox: innerOrOuter.value }),
                                        onClick: changeInnerOrOuter
                                    }, "国内", 2),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)({ chooseBox: !innerOrOuter.value }),
                                        onClick: changeInnerOrOuter
                                    }, "国际", 2)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    (0, vue_2.createVNode)(_component_SearchBox, {
                                        placeholder: "请输入数据指标名称",
                                        inputChange: inputChange,
                                        canOpen: false
                                    })
                                ]),
                                (0, vue_2.createVNode)(_component_a_button, {
                                    class: "back",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (goBack()))
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)("返回")
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createVNode)(_component_a_table, {
                                columns: columns,
                                "data-source": tableData.value,
                                scroll: { y: 'calc(100vh - 350px)', scrollToFirstRowOnChange: true },
                                pagination: {
                                    locale: {
                                        items_per_page: '/ 页',
                                    }
                                }
                            }, null, 8, ["data-source", "scroll"])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
